import { DoubleColor } from '@/__generated__/graphql'
import { GameDouble, GAME } from '@/components/molecules/StyledTable/StyledTable'

export const tranformDoubleGameDetails: (
  data: any
) => GameDouble & { randomness: string; state: string; created: Date; drawTimestamp: string; startBlock: string } = (
  data
) => {
  const game = data.doubleGame
  const userGame = data.doubleUserGames.nodes.at(0)

  return {
    id: game.id,
    gameId: game.id,
    address: game.address,
    state: game.state,
    denom: game.denom,
    randomness: game.randomness,
    created: new Date(game.created),
    drawTimestamp: game.drawTimestamp,
    winColor: game.winColor.toUpperCase() as DoubleColor,
    startBlock: game.startBlock,
    game: GAME.ROULETTE,
    totalBet: userGame.totalamount,
    winAmount: userGame.totalpayout,
    bets: {
      [DoubleColor.Black]: userGame.black,
      [DoubleColor.Red]: userGame.red,
      [DoubleColor.Green]: userGame.green,
    },
    jackpotAmount: userGame.totaljackpot || '0',
  }
}
